export default {
    main: {
        welcomePrefix: 'Bienvenido',
        welcomeSufix: 'a tu cuenta de negocios',
    },
    services: {
        title: 'Servicios',

        PrivateTransfers: {
            title: 'Transferencia Privada',
        },
        ChauffeurServices: {
            title: 'Choferes Privados',
        },
        TailorMade: {
            title: 'Servicios a Medida',
        },
        CouchesTransportation: {
            title: 'Transporte grupal'
        },
    },
    faq: {
        title: 'FAQ',
    },
    aboutUs: {
        title: 'Quienes Somos',
    },
    corporate: {
        title: 'Corporacion',
    },
    privacyPolicy: {
        title: 'Politicas de Privacidad',
    },
    termsConditions: {
        title: 'Terminos y Condiciones',
    },
    contacts: {
        title: 'Contactos',
    },
    travelAgents: {
        title: 'Agencias de Viaje',
    },
    destination: {
        title: 'Destinos',
    },
    login: {
        title: 'Ingresar',
    },
    register: {
        title: 'Registrar',
    },
    profile: {
        title: 'Perfil',
    },
    reservations: {
        title: 'Reservaciones',
    },
    payments: {
        title: 'Pagos',
    },
    paymentMethods: {
        title: 'Metodos de Pago',
    },
    settings: {
        title: 'Configuraciones',
    },
    logout: {
        title: 'Salir',
    },
    currencies: {
        labels: {
            one: 'Top Monedas',
            two: 'Todas las Monedas'
        }
    },
    footer: {
        copyright: 'Todos los Derechos Reservados'
    },

}